export const isPasswordSignInEnabled = (): boolean => import.meta.env.VITE_PASSWORD_SIGN_IN_ENABLED === 'true';
